import { render, staticRenderFns } from "./Startseite Education.vue?vue&type=template&id=5e13d16e"
import script from "./Startseite Education.vue?vue&type=script&lang=js"
export * from "./Startseite Education.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports